import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer-app',
  imports: [RouterModule],
  template: `
    <footer
      class="border-t border-gray-100 dark:border-slate-800 bg-white dark:bg-slate-900 transition-colors duration-200"
    >
      <div
        class="max-w-7xl mx-auto px-4 py-3 flex flex-wrap items-center justify-between gap-2 text-xs text-gray-400 dark:text-gray-500 dark:text-gray-400"
      >
        <span
          >&copy; {{ currentYear }} Predivent &mdash; Vends plus, gaspille
          moins.</span
        >
        <nav class="flex items-center gap-4">
          <a
            routerLink="/dashboard"
            class="hover:text-gray-700 dark:hover:text-gray-200 dark:text-gray-300 dark:hover:text-gray-300 transition"
            >Dashboard</a
          >
          <a
            routerLink="/profile"
            class="hover:text-gray-700 dark:hover:text-gray-200 dark:text-gray-300 dark:hover:text-gray-300 transition"
            >Profil</a
          >
          <a
            routerLink="/settings"
            class="hover:text-gray-700 dark:hover:text-gray-200 dark:text-gray-300 dark:hover:text-gray-300 transition"
            >Paramètres</a
          >
          <a
            routerLink="/contact"
            class="hover:text-gray-700 dark:hover:text-gray-200 dark:text-gray-300 dark:hover:text-gray-300 transition"
            >Support</a
          >
          <a
            routerLink="/cgu"
            class="hover:text-gray-700 dark:hover:text-gray-200 dark:text-gray-300 dark:hover:text-gray-300 transition"
            >CGU</a
          >
          <a
            routerLink="/confidentialite"
            class="hover:text-gray-700 dark:hover:text-gray-200 dark:text-gray-300 dark:hover:text-gray-300 transition"
            >Confidentialité</a
          >
        </nav>
      </div>
    </footer>
  `,
})
export class FooterAppComponent {
  currentYear = new Date().getFullYear();
}
